<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9 16.0002H15C15.55 16.0002 16 15.5502 16 15.0002V9.00018C16 8.45018 15.55 8.00018 15 8.00018H9C8.45 8.00018 8 8.45018 8 9.00018V15.0002C8 15.5502 8.45 16.0002 9 16.0002ZM12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018Z"
  />
</template>
